/* eslint-disable import/extensions */
import { createColorPaletteWidget, createColorPaletteTitleWidget } from '../utils.js';
import { hideableLayoutContextMenuItems, hideableLayoutFunc } from './hideable-layout.js';

const templateConfig = {
	tagName: 'HideableLayout',
	key: 'templateHideableLayout',
	contextMenuItems: hideableLayoutContextMenuItems,
	func: hideableLayoutFunc,
	title: { desc: 'Sankey18', name: 'template' },
	children: [
		{
			tagName: 'HorizontalLayout',
			className: 'horizontal-flex-space-between color-by',
			children: [
				{
					tagName: 'Text',
					className: 'format-select-text',
					text: { desc: 'Sankey19', name: 'Color by' }
				},
				{
					tagName: 'Select',
					key: 'colorByNode',
					options: [
						{ name: { desc: 'Sankey20', name: 'Node' }, value: true },
						{ name: { desc: 'Sankey21', name: 'Level' }, value: false }
					]
				}
			]
		},
		createColorPaletteTitleWidget('nodeColorPaletteTitle'),
		createColorPaletteWidget('nodeColorPalette'),
		{ tagName: 'Divider' }
	]
};

export default templateConfig;
